import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AzureApiService } from "../../services/azure-api.service";
import {DtoArticleInfoFilter} from "./models/DtoArticleInfoFilter";
import {DtoArticleInfo} from "./models/DtoArticleInfo";
import {DtoArticleInfoBaseItems} from "./models/DtoArticleInfoBaseItems";

@Injectable()
export class ArticleInfoService {
    private apiUrl: string;

    constructor(private http: AzureApiService) {
        this.apiUrl = 'management'
    }

    public getArticleInfo = (filter: DtoArticleInfoFilter): Observable<DtoArticleInfo> => {
        return this.http.post<DtoArticleInfo>(`${this.apiUrl}/articleinfo/`, filter);
    };

    public getArticleInfoBaseItems = (): Observable<DtoArticleInfoBaseItems> => {
        return this.http.get<DtoArticleInfoBaseItems>(`${this.apiUrl}/articleinfo/baseitems`);
    };
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/management/article-info/article-info.service.ts